export default {
	'{days}天后': '{days}日後',
	今日到期: '本日期限',
	'已过期{days}天': '{days}日超過',
}
